import get from 'lodash/get';

import api from '../lib/api';

export const RIDES_LOADING = 'RIDES_LOADING';
export const RIDE_WITH_ROUTE_BY_TRIP_ID = 'RIDE_WITH_ROUTE_BY_TRIP_ID';
export const FETCH_RIDES_FOR_VEHICLE = 'FETCH_RIDES_FOR_VEHICLE';

function fetchRidesByVehicleId(vehicleId) {
  return (dispatch) => {
    dispatch({ type: RIDES_LOADING, payload: true });

    return api.getVehicleTripsById(vehicleId)
      .then((data) => {
        dispatch({ type: FETCH_RIDES_FOR_VEHICLE, payload: { vehicleId, rides: data } });
        return data;
      })
      .then((data) => {
        dispatch({ type: RIDES_LOADING, payload: false });
        return data;
      })
      .catch(() => {
        dispatch({ type: RIDES_LOADING, payload: false });
      });
  };
}

export default {
  fetchRidesByVehicleId,
  fetchRideWithRouteByTripId(tripId) {
    return (dispatch) => {
      dispatch({ type: RIDES_LOADING, payload: true });

      return api.getRideWithRouteByTripId(tripId)
        .then((data) => {
          dispatch({ type: RIDE_WITH_ROUTE_BY_TRIP_ID, payload: { tripId, rides: get(data, 'data', []) } });
        })
        .then(() => {
          dispatch({ type: RIDES_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: RIDES_LOADING, payload: false });
        });
    };
  },
};
